<template>
  <div class="wrappers">
    <div class="homesinfo">
      <div class="topArea">
          <div class="topPart">
            <div style="width: 100%" >
              <div style="text-align: center;margin-bottom: 10px">
                学习时长
              </div>
                <span style="font-size: 0.8rem;font-weight:100;text-overflow:ellipsis;white-space:nowrap;overflow: hidden;display: inline-block;width: 100%;text-align: center" v-html="learnTime"></span>
            </div>

          </div>
          <div class="topPart">
            <div style="width: 100%">
              <div style="text-align: center;margin-bottom: 10px">
                超过平台
              </div>
              <span style="font-size:0.8rem;font-weight:100;text-overflow:ellipsis;white-space:nowrap;display: inline-block;width: 100%;text-align: center ">{{this.toFixed(learn_total_ratio,2).split('.')[0]}}<span style="font-size: 0.4rem">.{{this.toFixed(learn_total_ratio,2).split('.')[1]}}</span><span style="font-size: 0.3rem">%学员</span>
              </span>
            </div>

          </div>
      </div>
      <div class="studyPartContainer" >
        <van-row type="flex" justify="center"  ref="innerObj" style="padding: 10px 0px;width: 100%;">
          <van-col span="24">
            <van-card  class="myCardx">
              <template #thumb>
                <van-image
                  round
                  fit="cover"
                  width="2rem"
                  height="2rem"
                  :src="user.headimgurl?user.headimgurl:'https://img01.yzcdn.cn/vant/cat.jpeg'"
                />
              </template>
              <template #title>
                <span style="font-weight: bolder;font-size:0.5rem">{{user.staffname}}</span>
                <!--<span style="padding-left: 10px;font-size: 0.4rem">-->
                    <!--<van-icon name="star-o" color="orange" style="padding-left: 5px" />-->
                  <!--<van-icon name="like-o" color="orange" style="padding-left: 5px" />-->
                  <!--<van-icon name="fire-o" color="orange"  style="padding-left: 5px"/>-->
                  <!--<van-icon name="gem-o"  color="orange"  style="padding-left: 5px"/>-->
                 <!--</span>-->
              </template>
              <template #desc>
                <div style="padding-top: 10px;font-size: 0.3rem">
                  参加的学习小组:  {{mediaLearnData.team_total?mediaLearnData.team_total:0}}
                </div>
                <div style="font-size: 0.3rem;padding-top: 5px;">
                 <span>订阅的课程:  {{mediaLearnData.vip?mediaLearnData.info_buy_total:0}}/{{mediaLearnData.vip?mediaLearnData.vip.buy_count:0}}</span>
                  <span  style="padding-left: 4px" ><van-tag  type="danger" @click="()=>{ exShow=true }">兑换详情</van-tag></span>
                </div>

              </template>
            </van-card>
          </van-col>
          <van-col span="24">
            <div style="text-align: left;font-size: 0.4rem;font-weight: bold;padding-left: 10px;padding-bottom: 4px" >我的榜单</div>
          </van-col>
          <van-col span="24" style="height: auto;overflow: hidden">
            <van-cell-group>
              <van-cell  v-for="(v,i) in mediaTeamShowList" :key="i">
                <template #title>
                  <div style="text-align: left;font-size: 13px">
                    <span class="oneLine" style="width: 70px" >{{v.team_name}}</span>
                    <span class="oneLine" style="padding-left:5px">{{formatSeconds2(v.learn_total_time)}}</span>
                  </div>
                </template>
                <template >
                  <div style="text-align: right;font-size: 13px; white-space: nowrap;overflow:hidden;">
                    <span  class="oneLine" style="width: 60px;padding-right: 5px;text-align: left;font-weight: bold;color: black" >{{v.learn_rank}}/{{v.user_list?v.user_list.length:0}}</span>
                    <span  class="oneLine" ><van-tag type="danger" @click="toMediaTeamUser(v.user_list,v.team_name)">查看榜单</van-tag></span>
                  </div>

                </template>
              </van-cell>

            </van-cell-group>
          </van-col>
          <van-col span="24" style="height: auto;overflow: hidden;text-align: center;padding-top: 5px">
            <span @click="changeMediaTeamList()">
              <van-icon v-if="arrowFlag" name="arrow-down" color="orange" />
              <van-icon v-else name="arrow-up" color="orange" />
              所有排名
            </span>
          </van-col>
        </van-row>
      </div>
      <!--<div class="myLearn">-->
        <!--&lt;!&ndash;<div v-for="info of recommendList" :key="info.id" class="rwrapper" @click="()=>openVideo(info)">&ndash;&gt;-->
          <!--&lt;!&ndash;<img :src="info.bg" />&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="rtitle">{{ info.title }}</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="info">&ndash;&gt;-->
            <!--&lt;!&ndash;<div>{{`${info.file_total}节/${Number(info.duration/60).toFixed(0)}分钟`}}</div>&ndash;&gt;-->
            <!--&lt;!&ndash;<div>{{`${info.learn_user_total || 1}人学过`}}</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--<van-tabs v-model="activeName"   ref="vanTabs" style="width:100%">-->
          <!--<van-tab title="我的课程" name="a">-->
            <!--<div  class="tab-item">-->
              <!--&lt;!&ndash;<div style="padding: 8px 10px">&ndash;&gt;-->
                <!--&lt;!&ndash;<span style="font-weight: bolder;font-size: 16px">我的课程</span>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->

              <!--<van-card class="itemI"  v-for="item in recommendList" :key="item.file_id" @click="()=>openVideo(item)" :class="item.off?'off':null">-->
                <!--<template #thumb>-->
                  <!--<van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.info_bg"/>-->
                <!--</template>-->
                <!--<template #title>-->
                  <!--<div style="font-weight: bolder">{{item.info_title}}</div>-->
                  <!--<div style="font-size: 12px;margin-top: 2px">{{item.file_title}}</div>-->
                <!--</template>-->

                <!--<template v-if="item.linktype!==8" #bottom>-->
                  <!--<div style="position: relative;top: -6px">-->
                    <!--<div style="display: flex;justify-content: space-between">-->
                      <!--<span class="proText" >学习进度:  {{item.file_play_rate?item.file_play_rate.toFixed(2):0}}%</span>-->
                      <!--<span  class="buyTime">共{{s_to_hs(item.file_duration)}}</span>-->
                    <!--</div>-->
                    <!--<van-progress :percentage="item.file_play_rate?item.file_play_rate.toFixed(2):0"  pivot-text="" :color=" item.push_time != null && item.approval_time != null &&item. approval > 0?'rgb(66 238 10)':'#b3b3b3'"/>-->
                  <!--</div>-->
                <!--</template>-->
                <!--<template v-else #bottom>-->
                  <!--<div style="position: relative;top: 0px">-->
                    <!--<div style="display: flex;justify-content: space-between">-->
                      <!--<div class="buyTime">最近学习:{{item.update_time}}</div>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</template>-->
              <!--</van-card>-->

            <!--</div>-->
          <!--</van-tab>-->
          <!--<van-tab title="学习计划" name="c">-->
            <!--<div  class="tab-item">-->
              <!--&lt;!&ndash;<div style="padding: 8px 10px">&ndash;&gt;-->
              <!--&lt;!&ndash;<span style="font-weight: bolder;font-size: 16px">我的课程</span>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
              <!--<van-card class="itemI" v-for="item in studyPlanList" :key="item.file_id" @click="()=>openVideo2(item)" :class="item.push_time != null && item.approval_time != null &&item. approval > 0?null:'off'">-->
                <!--<template #thumb>-->
                  <!--<van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.bg"/>-->
                <!--</template>-->
                <!--<template #title>-->
                  <!--<span>{{item.title}}</span>-->
                <!--</template>-->
                <!--<template #price>-->
                  <!--<div style="color: #969799;">已看:{{item.info_play_rate?item.info_play_rate.toFixed(2):0}}%</div>-->
                  <!--<span style="color: #969799;">共{{s_to_hs(item.duration)}}</span>-->
                <!--</template>-->
                <!--<template #bottom>-->
                  <!--<div style="position: relative;top: 0px">-->
                    <!--<div style="display: flex;justify-content: space-between">-->
                      <!--<div class="buyTime">加入时间:{{item.team_info_time}}</div>-->

                    <!--</div>-->
                    <!--<div style="display: flex;justify-content: space-between">-->
                      <!--<div class="buyTime" v-if="item.learn_time">过期时间:{{item.learn_time}}</div>-->

                    <!--</div>-->
                  <!--</div>-->
                <!--</template>-->
                <!--&lt;!&ndash;<template #bottom>&ndash;&gt;-->
                  <!--&lt;!&ndash;<div style="position: relative;top: -6px">&ndash;&gt;-->
                    <!--&lt;!&ndash;<div style="display: flex;justify-content: space-between">&ndash;&gt;-->
                      <!--&lt;!&ndash;<span style="color: rgb(13 221 135)">学习进度:  {{((item.file_position/item.file_duration)*100).toFixed(0)}}%</span>&ndash;&gt;-->
                      <!--&lt;!&ndash;<span style="color: #fb891a">共{{s_to_hs(item.file_duration)}}</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;<van-progress :percentage="(item.file_position/item.file_duration)*100"  pivot-text="" color="rgb(66 238 10)"/>&ndash;&gt;-->
                  <!--&lt;!&ndash;</div>&ndash;&gt;-->

                <!--&lt;!&ndash;</template>&ndash;&gt;-->
              <!--</van-card>-->
            <!--</div>-->
          <!--</van-tab>-->
          <!--<van-tab title="购买列表" name="b">-->
            <!--<div class="tab-item">-->
              <!--&lt;!&ndash;<div style="padding: 8px 10px">&ndash;&gt;-->
                <!--&lt;!&ndash;<span style="font-weight: bolder;font-size: 16px">我的课程</span>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
              <!--<van-card class="itemI item2" v-for="item in buyList" :key="item.file_id" @click="toBuyed(item)"  >-->
                <!--<template #thumb>-->
                  <!--<van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.info.bg" />-->
                <!--</template>-->
                <!--<template #title>-->
                  <!--<span>{{item.info.title}}</span>-->
                <!--</template>-->
                <!--<template #price>-->
                   <!--<span style="position: relative;top:-2px;color: #969799;font-size: 10px;">原价:{{item.info.price/100}}元</span>-->
                   <!--<span style="position: relative;top:-2px;padding-left: 4px;font-size: 14px">实际支付:{{item.info.total_fee/100}}元</span>-->
                <!--</template>-->
                <!--<template #bottom>-->
                  <!--<div style="position: relative;top: 0px">-->
                    <!--<div style="display: flex;justify-content: space-between">-->
                      <!--<span style="color: #fb891a">下单时间:{{item.buy_time}}</span>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</template>-->
              <!--</van-card>-->
            <!--</div>-->
          <!--</van-tab>-->
        <!--</van-tabs>-->

      <!--</div>-->
      <div class="myLearn">
        <!--<span style="position: absolute;right: 10px;top: 15px;"><van-icon name="apps-o" size="24px" /></span>-->
        <van-tabs v-model:active="active" shrink>
          <van-tab title="学习计划">
            <div class="myTags">
              <span v-for="(v,i) in tagList" :key="i" class="fitem" >
                <van-badge v-if="v.badge_number>0" :content="v.badge_number" >
                    <van-tag   type="primary"  :plain="currentIndex==v.id?true:false" color="#DD5A6A" @click="selectTag(v)">{{v.type}}</van-tag>
                </van-badge>
                <span v-else>
                   <van-tag   type="primary" :plain="currentIndex==v.id?true:false" color="#DD5A6A" @click="selectTag(v)">{{v.type}}</van-tag>
                </span>
              </span>
            </div>
            <div>
              <van-row  gutter="30" style="padding-top: 10px ">
                <van-col  span="24">
                  <van-cell-group inset border class="myCell">
                    <!--<van-cell border is-link arrow-direction="down" :value="内容" @click="showPicker=true"/>-->
                    <van-field
                      v-model="selectValue"
                      is-link
                      readonly
                      placeholder="课程分类筛选"
                      @click="showPicker = true"
                    />
                    <van-popup v-model:show="showPicker" round position="bottom">
                      <van-picker
                        show-toolbar
                        title="课程分类"
                        :columns="schoollist"
                        @cancel="showPicker = false"
                        @confirm="onConfirm"
                      />
                    </van-popup>
                  </van-cell-group>

                </van-col>
                <!--<van-col span="16">-->
                  <!--<van-cell-group inset border class="myCell">-->
                    <!--<van-cell border is-link arrow-direction="down" value="内容" />-->
                    <!--<van-popup v-model:show="showPicker" position="bottom">-->
                      <!--<van-picker-->
                        <!--:columns="columns"-->
                        <!--@confirm="onConfirm"-->
                        <!--@cancel="showPicker = false"-->
                      <!--/>-->
                    <!--</van-popup>-->
                  <!--</van-cell-group>-->
                <!--</van-col>-->
              </van-row>
            </div>
            <div  class="tab-item"  style="padding-top: 10px">
              <van-empty style="background-color: transparent"  v-if="courseList.length==0" description="列表为空" />
              <van-card v-if="currentIndex==1||currentIndex==3" class="itemI"  v-for="item in courseList" :key="item.id" @click="()=>openVideo(item)"  :class="item.ifSx?'gq':item.info_play_rate==100?'wc':item.ifVip?'vip':'fp'">
                <template #thumb>
                  <van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.bg"/>
                  </template>
                <template #title>
                  <div style="font-weight: bolder">{{item.title}}</div>
                  <div style="font-size: 12px;margin-top: 2px">{{item.last_play.file_title?item.last_play.file_title:null}}</div>
                  <div  v-if="item.linktype!==8" style="font-size: 12px;margin-top: 2px">最近学习时间:{{formatYMD(item.last_play.update_time)}}</div>
                </template>

                <template v-if="item.linktype!==8" #bottom>
                  <div style="position: relative;top: 0px">
                    <div style="display: flex;justify-content: space-between">
                      <span class="proText" >学习进度:  {{item.last_play.file_play_rate?item.last_play.file_play_rate.toFixed(2):0}}%</span>
                      <span  class="buyTime">共{{s_to_hs(item.last_play.file_duration)}}</span>
                    </div>
                    <van-progress :percentage="item.last_play.file_play_rate?item.last_play.file_play_rate.toFixed(2):0"  pivot-text="" color="#42EE0A"/>
                  </div>
                </template>
                <template v-else #bottom>
                  <div style="position: relative;top: 0px">
                    <div style="display: flex;justify-content: space-between">
                      <div class="buyTime" v-if="item.last_play.update_time">最近学习:{{formatYMD(item.last_play.update_time)}}</div>
                    </div>
                  </div>
                </template>
              </van-card>
              <van-card  v-if="currentIndex==2||currentIndex==4||currentIndex==5||currentIndex==6" class="itemI" v-for="item in courseList" :key="item.id" @click="()=>openVideo2(item)" :class="item.ifSx?'gq':item.info_play_rate==100?'wc':item.ifVip?'vip':'fp'">
                <template #thumb>
                  <van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.bg"/>
                </template>
                <template #title>
                  <span>{{item.title}}</span>
                </template>
                <template #price>
                  <div style="color: #969799;" v-if="currentIndex==2||currentIndex==5||currentIndex==6">已看:{{item.info_play_rate?item.info_play_rate.toFixed(2):0}}% </div>
                  <span style="color: #969799;">共{{s_to_hs(item.duration)}}</span>
                </template>
                <template #bottom>
                  <div style="position: relative;top: 0px" v-if="currentIndex==2">
                    <div style="display: flex;justify-content: space-between" v-if="item.last_play_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">最近学习时间:{{formatYMD(item.last_play_time)}}</div>
                    </div>
                    <div style="display: flex;justify-content: space-between"  v-if="item.learn_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">课程要求时间:{{formatYMD(item.learn_time)}}</div>
                    </div>
                    <div style="display: flex;justify-content: space-between"   v-if="item.overdue_time">
                      <div class="buyTime"   style="font-size: 12px;line-height: 15px">过期时间:{{item.overdue_time}}</div>
                    </div>
                  </div>
                  <div style="position: relative;top: 0px" v-if="currentIndex==4">
                    <div style="display: flex;justify-content: space-between" v-if="item.team_info_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">加入时间:{{formatYMD(item.team_info_time)}}</div>
                    </div>
                  </div>
                  <div style="position: relative;top: 0px" v-if="currentIndex==5">
                    <div style="display: flex;justify-content: space-between" v-if="item.last_play_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">最近学习时间:{{formatYMD(item.last_play_time)}}</div>
                    </div>
                    <div style="display: flex;justify-content: space-between" v-if="item.last_play_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">完成时间:{{formatYMD(item.complete_time)}}</div>
                    </div>
                  </div>
                  <div style="position: relative;top: 0px" v-if="currentIndex==6">
                    <div style="display: flex;justify-content: space-between" v-if="item.last_play_time">
                      <div class="buyTime" style="font-size: 12px;line-height: 15px">最近学习时间:{{formatYMD(item.last_play_time)}}</div>
                    </div>
                    <div style="display: flex;justify-content: space-between"   v-if="item.overdue_time">
                      <div class="buyTime"   style="font-size: 12px;line-height: 15px">过期时间:{{formatYMD(item.overdue_time)}}</div>
                    </div>
                  </div>
                </template>
                <!--<template #bottom>-->
                <!--<div style="position: relative;top: -6px">-->
                <!--<div style="display: flex;justify-content: space-between">-->
                <!--<span style="color: rgb(13 221 135)">学习进度:  {{((item.file_position/item.file_duration)*100).toFixed(0)}}%</span>-->
                <!--<span style="color: #fb891a">共{{s_to_hs(item.file_duration)}}</span>-->
                <!--</div>-->
                <!--<van-progress :percentage="(item.file_position/item.file_duration)*100"  pivot-text="" color="rgb(66 238 10)"/>-->
                <!--</div>-->

                <!--</template>-->
              </van-card>


            </div>
          </van-tab>
          <van-tab title="购买列表">
            <div class="myTags">
              <div class="tab-item">
                <van-card class="itemI item2" v-for="item in buyList" :key="item.file_id" @click="toBuyed(item)"  >
                  <template #thumb>
                   <van-image style="width:100%;height:auto;margin:auto;padding-right:8px" lazy-load :src="item.info.bg" />
                  </template>
                  <template #title>
                    <span>{{item.info.title}}</span>
                  </template>
                  <template #price>
                    <span style="position: relative;top:-2px;color: #969799;font-size: 10px;">原价:{{item.info.price/100}}元</span>
                    <span style="position: relative;top:-2px;padding-left: 4px;font-size: 14px">实际支付:{{item.info.total_fee/100}}元</span>
                  </template>
                  <template #bottom>
                    <div style="position: relative;top: 0px">
                      <div style="display: flex;justify-content: space-between">
                        <span style="color: #fb891a">下单时间:{{item.buy_time}}</span>
                      </div>
                    </div>
                  </template>
                </van-card>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <van-dialog v-model="exShow" overlay :show-confirm-button="false" >
        <div slot="title">
          兑换详情
          <span  style="padding-left: 4px;color: #e7143a;font-size: 14px;position: absolute;top: 15px;right: 30px"  @click="()=>{ exShow=false }">返回</span>
        </div>
        <div v-if="vipInfoList.length>0" style="padding: 10px;height: 50vh;overflow: auto">
          <van-collapse v-model="activeNames">
            <van-collapse-item v-for="(v,index) in vipInfoList" :title="v.category+' '+v.use_count+'/'+v.buy_count" :key="v.category_id" :name="index">
              <van-cell v-for="item in v.child_list" :key="item.category_id" :title="item.category">
                <span slot>
                  <span style="padding-right: 5px">{{item.use_count+'/'+item.buy_count}}</span> <van-tag  type="danger" @click="toListExchange(item)">前去兑换</van-tag>
                </span>
              </van-cell>
            </van-collapse-item>
          </van-collapse>
        </div>
        <van-empty v-else description="暂无数据" />
      </van-dialog>
    </div>
    <tab/>
  </div>
</template>
<script>
  import Tab from './tab';
  import { mediaLearn, getInfo,mediaTeamInfoGet,mediaTeamGet,txInfoUrl,mediaPlanGet,mediaPlanTypeGet,mediaVipGet } from '@/api/shopapi';
  import moment from 'moment'
  export default {
    name: 'schoolInfo',
    components: {
      Tab,
    },
    data () {
      return {
        user:{},
        recommendList:[],
        mediaLearnData:{},
        learn_total_time:0,
        learn_total_ratio:0,
        activeName: 'a',
        buyList:[],
        studyPlanList:[],
        activeName2:'1',
        mediaTeamList:[],
        mediaTeamListParts:[],
        mediaTeamShowList:[],
        arrowFlag:true,
        active:0,
        tagList:['最近学习','我的课程','学习中','最新课程','完成课程','失效课程'],
        showPicker:false,
        selectValue:null,
        currentIndex:2,
        currentTag:{},
        courseList:[],
        exShow:false,
        activeNames: [0],
        vipInfoList:[],
        selectValueS:'全部'
      }

    },
    computed: {
      learnTime(){
        return this.formatSeconds(this.learn_total_time)
      },
      schoollist () {
        console.log('getSchoolist',this.$store.getters.getSchoolist)
        let arr=this.$store.getters.getSchoolist
        arr.map(m=>{
          m.text=m.category
          if(m.child_list&&m.child_list.length>0){
            let newarr= m.child_list.map(x=>{
              x.text=x.category
              return x
            })
            m.children=newarr
          }else{
            m.children=[]
          }

        })
        console.log('teamList',this.mediaTeamList)
        if(this.mediaTeamList.length>0){
          let sarr=JSON.parse(JSON.stringify(this.mediaTeamList))
          sarr.map(v=>{
            v.text=v.team_name
          })
          console.log('```````````````',arr)
          let obj={
            app_disable: false,
            category: "学习小组",
            category_id: null,
            children:sarr,
            text: "学习小组"
          }
          arr=[obj ,...arr]
        }
        let obj={
          app_disable: false,
          category: "文博学院",
          category_id: 20000,
          children:[{text:'全部'}],
          text: "全部"
        }
        arr=[obj ,...arr]
        console.log('arrarr',arr)
        console.log('this.mediaTeamList',this.mediaTeamList)
        return arr
      },

    },
    async mounted () {
      this.user = this.$store.getters.getUser;
      const res = await mediaLearn({info_type:0,page_no: 0,
        page_size: 10000000})
      if(res.code=='000'){
        console.log('resmediaLearn',res)
        this.mediaLearnData=res.data
        if(res.data.last_info_list&&res.data.last_info_list.length>0){
          // let arr=res.data.last_info_list.filter(x=>{
          //   if(x.file_duration!==0){
          //     return x
          //   }
          // })
          let arr=res.data.last_info_list
          this.$nextTick(()=>{
            this.recommendList = arr.map(m=>{
              m.info_bg = m.info_bg || '../../../static/img/bg/ept2.jpg'
              m.off=m.push_time != null && m.approval_time != null &&m. approval > 0?false:true
              return m
            })
          })


        }
        this.buyList=res.data.buy_list.filter(f=>f.info)
        this.learn_total_time=res.data.learn_total_time
        console.log('his.learn_total_time',res.data.learn_total_time)
        this.learn_total_ratio=res.data.learn_total_ratio
      }
      const teamInfoRes=await mediaTeamInfoGet({team_id:null,page_no: 0, page_size: 10000000})
      if(res.code=='000'){
        this.studyPlanList=teamInfoRes.data.data_list
        console.log('studyPlanListstudyPlanListstudyPlanList',this.studyPlanList)
      }else{
        console.log('学习计划获取失败')
      }
     const mediaTeamGetRes=await mediaTeamGet()
      if(mediaTeamGetRes.code=='000'){
        console.log('mediaTeamGetRes',mediaTeamGetRes)
        this.mediaTeamList=mediaTeamGetRes.data
        this.mediaTeamListParts=mediaTeamGetRes.data.slice(0,2)
        this.mediaTeamShowList=mediaTeamGetRes.data.slice(0,2)
      }else{
        console.log('获取学习小组失败')
      }
      const mediaPlanGetRes=await mediaPlanGet()
      if(mediaPlanGetRes.code=='000'){
        console.log('mediaPlanGetRes',mediaPlanGetRes)
         this.tagList=mediaPlanGetRes.data
          this.currentTag=mediaPlanGetRes.data[0]
        // this.mediaTeamListParts=mediaTeamGetRes.data.slice(0,2)
        // this.mediaTeamShowList=mediaTeamGetRes.data.slice(0,2)
      }else{
        this.$toast.fail('获取学习tag列表失败')
      }
      this.courseList=await  this.getPlanData({category_id:null,type:'我的课程'})
      console.log('courseList',this.courseList)
      const mediaVipGetRes=await mediaVipGet()
      if(mediaVipGetRes.code=='000'){
        console.log('mediaVipGetRes',mediaVipGetRes)
        this.vipInfoList=mediaVipGetRes.data
      }
    },
    methods: {
      async openVideo (info) {
        try {
          console.log('info', info)
          const res = await getInfo({
            category_id:  null,
            page_no: 0,
            page_size: 100000,
            title: info.title
          })
          const x = res.data.data_list.find(f=>f.id === info.id)
          if(x) {
            this.$router.push({ name: "PlayVideo",
              params: Object.assign({},x,{ file_id: info.file_id,file_position: info.file_position})})
          }
        } catch (e) {
          console.log(e)
        }
      },
      async openVideo2 (info) {
        console.log('infoopenVideo2openVideo2openVideo2openVideo2', info)
        if(info.ifSx){
          return
        }
        try {
          if(info.last_play){
            this.$router.push({ name: "PlayVideo",
              params: Object.assign({},info,{ file_id: info.last_play.file_id,file_position: info.last_play.file_position})})
          }else{
            this.$router.push({ name: "PlayVideo",
              params: Object.assign({},info,{ file_id: info.id,file_position: info.file_position})})
          }
        } catch (e) {
          console.log(e)
        }
      },
      s_to_hs(s){
          //计算分钟
          //算法：将秒数除以60，然后下舍入，既得到分钟数
          var h;
          h  =   Math.floor(s/60);
          //计算秒
          //算法：取得秒%60的余数，既得到秒数
          s  =   s%60;
          //将变量转换为字符串
          h    +=    '';
          s    +=    '';
          //如果只有一位数，前面增加一个0
          h  =   (h.length==1)?'0'+h:h;
          s  =   (s.length==1)?'0'+s:s;
          return h+':'+s;
        },
      formatSeconds(value) {
        let result = parseInt(value)
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
        let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
        result = `${h}<span style="font-size: 0.3rem;"> 时</span><span style="font-size: 0.4rem"> ${m} </span><span style="font-size: 0.3rem;">分</span>`
        return result
      },
      formatSeconds2(value) {
        let result = parseInt(value)
        let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
        let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
        let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
        result = `${h} 时 ${m}分`
        return result
      },
      toFixed(number, decimal) {
        decimal = decimal || 0;
        var s = String(number);
        var decimalIndex = s.indexOf('.');
        if (decimalIndex < 0) {
          var fraction = '';
          for (var i = 0; i < decimal; i++) {
            fraction += '0';
          }
          return s + '.' + fraction;
        }
        var numDigits = s.length - 1 - decimalIndex;
        if (numDigits <= decimal) {
          var fraction = '';
          for (var i = 0; i < decimal - numDigits; i++) {
            fraction += '0';
          }
          return s + fraction;
        }
        var digits = s.split('');
        var pos = decimalIndex + decimal;
        var roundDigit = digits[pos + 1];
        if (roundDigit > 4) {
          //跳过小数点
          if (pos == decimalIndex) {
            --pos;
          }
          digits[pos] = Number(digits[pos] || 0) + 1;
          //循环进位
          while (digits[pos] == 10) {
            digits[pos] = 0;
            --pos;
            if (pos == decimalIndex) {
              --pos;
            }
            digits[pos] = Number(digits[pos] || 0) + 1;
          }
        }
        //避免包含末尾的.符号
        if (decimal == 0) {
          decimal--;
        }
        return digits.slice(0, decimalIndex + decimal + 1).join('');
      },
      resizeTabs(){
        console.log('1221212')
        this.$refs.vanTabs.resize();
      },
     async toBuyed(x){
        console.log('11111?',x)
        if(x.info.channel_type=='keqq'){
          console.log('res',x)
          let info=x
          try {
            console.log('info', info)
            const res = await getInfo({
              category_id:  null,
              page_no: 0,
              page_size: 100000,
              title: info.info.title
            })
            const x = res.data.data_list.find(f=>f.id === info.info_id)
            if(x) {
              this.$router.push({ name: "PlayVideo",
                params: Object.assign({},x,)})
            }
          } catch (e) {
            console.log(e)
          }

        }else{
          if (x.info.buy_url) {
            location.href = x.info.buy_url
            return
          }
          if (x.info.url) {
            location.href = x.info.url
            return
          }
        }


      },
      changeMediaTeamList(){
        console.log('1111')
       if(this.arrowFlag){
         this.mediaTeamShowList=this.mediaTeamList
       }else{
         this.mediaTeamShowList=this.mediaTeamListParts
       }
        this.arrowFlag=!this.arrowFlag
      },
      toMediaTeamUser(x,y){
        console.log('xxx',x)
        this.$store.dispatch("setMediaTeamUserList", x);
        this.$router.push({
          path:`/mediaTeamUser`,
          query: {
            teamName:y
          }
        })
      },
     async onConfirm(value,index){
        console.log('111',value)
        console.log('222',index)
        console.log('3',this.schoollist[index[0]].children[index[1]])
        this.selectValue=value.join('/')
       this.selectValueS=value
       this.selectValueI=index
        let para={}
        if (value[0]=='全部'){
          para= {category_id:null,type:this.currentTag.type}
        }else{
          console.log('this.this.currentTag.type',this.currentTag.type)
          para=  {category_id:this.schoollist[index[0]].children[index[1]].category_id,type:this.currentTag.type,team_id:this.schoollist[index[0]].children[index[1]].team_id?this.schoollist[index[0]].children[index[1]].team_id:null}
        }
        console.log('para`````````````',para)
        this.courseList= await  this.getPlanData(para)
        this.showPicker=false
      },
     async selectTag(v){
        console.log('vvvvvvv',v)
        this.currentIndex=v.id
        this.currentTag=v
        this.courseList=[]
       /* this.selectValue=null*/
        const mediaPlanGetRes=await mediaPlanGet()
        if(mediaPlanGetRes.code=='000'){
          console.log('mediaPlanGetRes',mediaPlanGetRes)
          this.tagList=mediaPlanGetRes.data
          // this.currentTag=mediaPlanGetRes.data[0]
          // this.mediaTeamListParts=mediaTeamGetRes.data.slice(0,2)
          // this.mediaTeamShowList=mediaTeamGetRes.data.slice(0,2)
        }else{
          this.$toast.fail('获取学习tag列表失败')
        }
        this.$nextTick(async ()=>{
          let para={}
          let value=this.selectValueS
          let index=this.selectValueI
          console.log("index",index)
          console.log("value",value)
          if (value=='全部'){
            para= {category_id:null,type:this.currentTag.type}
          }else{
            console.log('this.this.currentTag.type',this.currentTag.type)
            para=  {category_id:this.schoollist[index[0]].children[index[1]].category_id,type:this.currentTag.type,team_id:this.schoollist[index[0]].children[index[1]].team_id?this.schoollist[index[0]].children[index[1]].team_id:null}
          }
           this.courseList= await  this.getPlanData(para)

        })

      },
     async getPlanData(para){
       const toast = this.$toast.loading({
         message: '加载中...',
         forbidClick: true,
         overlay:true
       });
       const Res=await mediaPlanTypeGet(para)
       if(Res.code=='000'){
         console.log('mediaPlanGetRes',Res)
         let arr=Res.data
         const format = 'dd-mm-yyyy'
         const time = moment(new Date(),format)
         arr.map(m=>{
           m.bg = m.bg || '../../../static/img/bg/ept2.jpg'
           m.off=m.push_time != null && m.approval_time != null &&m. approval > 0?false:true
           m.ifVip=m.buy?true:false
          if(para.type=='失效课程'){
            m.ifSx=true
          }else{
            if(m.overdue_time){
              //let beforeTime = moment(m.overdue_time, format)
              if(moment().isBefore(m.overdue_time)){
                console.log('1111',m.overdue_time)
                m.ifSx=false
              }else{
                console.log('22222',m.overdue_time)
                m.ifSx=true
              }
            }else{
              m.ifSx=false
            }
          }
          return m
         })
         console.log('arrr1111111',arr)
         toast.clear();
         return arr
       }else{
         toast.clear();
         this.$toast.fail('获取数据失败')
         return []
       }
      },
     formatYMD(x){
       return moment(x).format("YYYY-MM-DD")
     },
      toListExchange(v){
        console.log('vvvv',v)
        this.$router.push({ name: "SchoolList", params: v });
      }
    }
  }
</script>
<style>
  .homesinfo{
    width: 100%;
    height: 100vh;
    /* background: url("../../../static/img/school/schoolInfo.png") no-repeat; */
    background-size: contain;
  }
  .topArea{
    display: flex;
    height: 150px;
  }
  .topPart{
    width: 50%;
    text-align: center;
    vertical-align: center;
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*实现水平居中*/
    justify-content: center;
    text-align: justify;
    background: transparent;
    margin:0 auto;
    color:black;

  }
  .myLearn {
    flex: 1;
    /*margin: 0px 10px 0px 10px;*/
    padding: 0px 10px 0px 10px;
    width: calc(100vw - 20px);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    background: white;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 50px;
  }

  /*.itemI{*/
    /*margin: 10px 10px;*/
  /*}*/
  .itemI .van-card__thumb {
    width: 35% !important;
  }
  .itemI .van-image__img {
    border-radius: 0 ;
  }
  .item2{
    width:  100%;
  }
  .tab-item{
    width: 100%;
  }
  .tab-item .van-card{
    padding-bottom: 2px!important;

  }
  .studyPartContainer{
    flex: 1;
    margin: 0px 10px 0px 10px;
    width: calc(100vw - 20px);
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    background: white;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
  .studyPart{
    flex-wrap: wrap;
    background-color: white;
    justify-content: flex-start;
    background-color: white;
    height: 200px;
  }
  .wrappers{
    background-color: #fafafa
  }
  .myCardx{
    padding: 0rem 0.426667rem;
    background-color: white;
  }
  .oneLine{
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    display: inline-block;
  }
  .gq::before{
    content: '已失效';
    background-color:red ;
    /*   width: 100%;
       height: 100%;*/
    position: absolute;
    opacity: 1!important;
    z-index: 99;
    left: 16px;
    top: 0;
    font-size: 12px;
    text-align: center;
    color: white;
    height: 45px;
    width: 20px;
    border-radius: 0 0 6px 6px;
    padding:3px 2px 10px 2px;
  }
  .gq{
    color:#b3b3b3!important;
  }
  .gq .buyTime{
    color:#b3b3b3!important;
  }
  .gq .proText{
    color:#b3b3b3!important;
  }
  .wc::before{
    content: '已完成';
    background-color:#87d068 ;
    /*   width: 100%;
       height: 100%;*/
    position: absolute;
    opacity: 1!important;
    z-index: 99;
    left: 16px;
    top: 0;
    font-size: 12px;
    text-align: center;
    color: white;
    height: 45px;
    width: 20px;
    border-radius: 0 0 6px 6px;
    padding:3px 2px 10px 2px;
  }
  .vip::before{
    content: 'vip购买';
    background-color:#87d068 ;
    /*   width: 100%;
       height: 100%;*/
    position: absolute;
    opacity: 1!important;
    z-index: 99;
    left: 16px;
    top: 0;
    font-size: 12px;
    text-align: center;
    color: white;
    height: 45px;
    width: 20px;
    border-radius: 0 0 6px 6px;
    padding:3px 2px 10px 2px;
  }
  .fp::before{
    content: '分配';
    background-color:#87d068 ;
    /*   width: 100%;
       height: 100%;*/
    position: absolute;
    opacity: 1!important;
    z-index: 99;
    left: 16px;
    top: 0;
    font-size: 12px;
    text-align: center;
    color: white;
    height: 45px;
    width: 20px;
    border-radius: 0 0 6px 6px;
    padding:3px 2px 10px 2px;
  }
  .buyTime{
    color:#fb891a
  }
  .proText{
    color: rgb(13 221 135);
  }
  .myTags{
    width: calc(100vw - 20px);
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    flex-flow: row wrap;
  }
  .fitem{
    flex: 0 0 20%;
    margin-bottom: 10px;
  }
  .fitem  .van-tag{
    border-radius: 4px;
    padding: 2px 5px;
    width: 52px;
    text-align: center;
  }
  .myLearn .van-tabs__wrap{
    width: 50%;
  }
  .myCell .van-cell{
    padding: 3px 4px;
    border-radius: 4px;
    border: 1px solid #cbcbcb;
  }
</style>

